<template>
  <div id="app">
    <div class="promote-app">
      <div class="gr-promote-app" v-show="isShowPromoteApp && isMobileApp()">
        <div class="media">
          <div class="media-body media-middle">
            <div class="d-flex align-items-center">
              <a href="javascript: void(0)" class="gr-btn text-center p-5 cursor-pointer" v-on:click="hidePromote()">
                <img src="https://static.phdvasia.com/sg1/icons/close%402x.png" width="12" alt="" />
              </a>
              <img src="https://static.phdvasia.com/my/logos/logo_home@x2_D.png" class="media-object img-logo p-5" width="50px">
              <div class="ml-5">
                <h4 class="media-heading align-self-center">{{$t('promote_app_title')}}</h4>
                <p class="align-self-center m-0">{{$t('promote_app_content')}}</p>
              </div>
            </div>
          </div>
          <div class="media-right media-middle">
            <button class="btn-new" type="button" v-on:click="onlinkRedirect">
              {{$t('promote_app_btn')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <component :is="layout">
      <router-view></router-view>
    </component>
    <notifications/>
    <notifications id="notifications" group="notifications"/>
    <count-down-timer></count-down-timer>
    <div class="override-loading popup-loading" v-bind:style="{display: loading}"></div>
    <v-dialog class="disposition-modal-confirm"/>
    <!-- <div class="override-loading popup-loading" style="display:block"></div> -->
  </div>
</template>

<style lang="scss">
  @import './assets/css/plugin/font-awesome.min.css';
  @import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
  @import './assets/css/main.css';
  @import './assets/css/home.css';
  @import './assets/css/fix.css';
  @import './assets/css/login.css';
  @import './assets/css/fix-all.css';
  @import 'assets/scss/main.scss';
  @import '@pizza-hut/fcds-ui/dist/fcds-ui.css';

  .alert {
    z-index: 999;
  }

  @media screen and (max-width: 48em) {
    #app {
      overflow: hidden;
    }
  }
</style>

<script>
  import moment from 'moment'
  import * as action from './store/actions'
  import CountDownTimer from './components/home/HomeCountDownTimerCloseOutlet.vue'
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import ModalDelivery from "./components/popup/ModalDelivery";
  import en from './assets/lang/en.json'

  const main = () => import('./main.js')
  const ModalNotify = () => import('./components/popup/ModalNotify')
  const ModalMaintain = () => import('./components/popup/ModalMaintain')
  const OrderASAP = () => import('./components/popup/OrderASAP')

  const defaultLayout = 'main'
  let isManipulate = false

  export default {
    name: 'App',
    data() {
      return {
        loading: 'none',
        loadingCount: 0,
        isManipulate: false,
        direction: 'ltr',
        isShowPromoteApp: false
      }
    },
    components: {
      CountDownTimer
    },
    watch: {
      '$route': {
        handler: 'routeChanged',
        //immediate: true,
      },
      loadingCount: function (newValue, oldValue) {
        if (this.loadingCount <= 0 && this.loading == 'none') {

        } else {
          if (this.loadingCount <= 0) {
            this.loading = 'none'
          } else {
            this.loading = 'block'
          }
        }
      },
      isManipulate: function (newValue, oldValue) {
        if (!newValue) {

        }
      }
    },
    computed: {
      ...mapGetters({
        selectedOrderTime: 'selectedOrderTime',
        categoryList: 'categoryList',
        selectedCategory: 'selectedCategory',
        selectedSubCategory: 'selectedSubCategory',
        lang: 'lang'
      }),
      layout() {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    },
    created: function () {
      let lang = this.$session.get('lang') || this.$const.DEFAULT_LANGUAGE
      this.setLang(lang)
      this.$cart.init(this)

      registerEvents(this)
      loadCSS(this)
      this.registerEventIdleTime()
      this.setDirection()
      this.getDataErrorMessage()
      this.initMaintainModeEvent()
      this.initABTesting(this,this.$const.AB_TESTING_FUNCTIONAL)
    },
    mounted() {
      let vm = this
      this.$root.$on('logout', () => {
        vm.logout()
      })
      this.$root.$on('onShowNotification', (title, message, action) => {
        title = title || vm.$t('message')
        message = message || vm.$t('message')
        vm.$modal.show(ModalNotify, {
          name: 'modal-notify',
          title: title,
          message: message,
          action: action
        }, {
          class: 'modal-menu',
          transition: 'nice-modal-fade',
          overlayTransition: 'overlay-fade',
          clickToClose: false,
          name: 'modal-notify'
        })
      })
      this.$root.$on('onProcessChangeCategory', () => {
        let menudeal = vm.$store.getters.menuDeal
        if (vm.empty(menudeal)) {
          let orderTime = vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''),
            vm.$disposition.getByKey(vm, 'collectionTimeValue', ''))
          if (!orderTime) {
            orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          }

          let data = {
            order_time: orderTime,
            outlet_code: vm.getOutletCode(vm)
          }

          vm.axios.getListCategory(data, function (response) {
            vm.data = response.data.data.items
            vm.$session.set('listCategory', response.data.data.items)
            let _menuDeal = {}
            for (let r in response.data.data.items) {
              _menuDeal = {
                slug: response.data.data.items[r].slug,
                uuid: response.data.data.items[r].uuid,
                lower_categories: response.data.data.items[r].lower_categories
              }
              break
            }
            if (vm.empty(_menuDeal) && response.data.data.items.length > 0) {
              _menuDeal = {
                slug: response.data.data.items[0].slug,
                uuid: response.data.data.items[0].uuid,
                lower_categories: response.data.data.items[0].lower_categories
              }
            }

            vm.$store.commit('setMenuDeal', _menuDeal)
            let slug = _menuDeal.slug
            // if (_menuDeal.lower_categories && _menuDeal.lower_categories.length > 0) {
            //   slug = _menuDeal.lower_categories[0].slug
            // }
            vm.$router.push({'name': 'category', 'params': {'slug': slug}})
          })
        } else {
          vm.$router.push({'name': 'category', 'params': {'slug': menudeal.slug}})
        }
      })

      this.smartechInit(vm)
    },
    beforeDestroy: function () {
      this.$bus.$off('loading');
    },
    methods: {
      ...mapActions({
        setOrderTime: 'setOrderTime',
        setCategoryList: action.SET_CATEGORY_LIST,
        setSelectedCategory: action.SET_SELECTED_CATEGORY,
        setSelectedSubCategory: action.SET_SELECTED_SUB_CATEGORY,
        setLang: action.SET_LANG,
        setUIDirection: action.SET_UI_DIRECTION
      }),
      hidePromote () {
        this.isShowPromoteApp = false
        const header = document.getElementById('container-header')
        if (header) {
          header.classList.add('hide-promote')
        }
        const menuItem = document.getElementById('container-menu-item')
        if (menuItem) {
          menuItem.classList.add('hide-promote')
        }
      },
      onlinkRedirect () {
        window.open(this.$const.ONE_LINK, '_blank')
      },
      logout: function () {
        this.$auth.logout({
          data: {
            token: this.$auth.user().token
          },
          success: function (response) {
            if (response.data.status) {
              if(this.$session.get('vouchers')) {
                this.$router.push({name: 'vouchers'})
              } else {
                this.$router.push('/')
              }

              this.$cart.removeAll(this, (err, res) => {
                // Clear cart after logout
              })
            } else {
              this.$notify({
                type: 'Error',
                title: response.data.error.msg
              })
            }
          },
          error: function (data) {
            this.$notify({
              type: 'Error',
              title: this.$t('message_logout_error')
            })
          }
        })
      },
      routeChanged() {
        let vm = this
        if (this.$auth.check()) {
          this.axios.apiCustomer.getProfile((response) => {
            let dataResponse = response.data.data.item
            
            let user = vm.$auth.user()
            if (user.point !== dataResponse.point) {
              user.point = dataResponse.point
              vm.$auth.user(user)
            }
          })
        }
        this.getCategoryList(false)
      },
      showOrderASAP: function (message) {
        let vm = this
        this.$modal.show(OrderASAP, {
            parentlink: vm.getCurrentPath(),
            message: message
          },
          {
            class: ''
          })
      },
      showModalDelivery: function (message) {
        let vm = this
        vm.$modal.show(ModalDelivery, {
          message: message,
          methodSearch: vm.$const.DEFAULT_CONFIG_APP,
          hideCollectionButton: false,
          chooseAnotherDelivery: function () {
          }
        })
      },
      showModalPickup: function (message) {
        let vm = this
        vm.$modal.show(ModalDelivery, {
          message: message,
          methodSearch: vm.$const.DEFAULT_CONFIG_APP,
          hideCollectionButton: true,
          chooseAnotherDelivery: function () {
          }
        })
      },
      getCategoryList: function (loadAgain = false) {
        let vm = this

        if (!vm.categoryList || !vm.categoryList.length || loadAgain) {
          let orderTime = vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''),
            vm.$disposition.getByKey(vm, 'collectionTimeValue', ''))
          if (!orderTime) {
            orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          }

          let request = {
            order_time: orderTime,
            outlet_code: vm.getOutletCode(vm),
            lang: vm.$session.get('lang')
          }

          request = vm.parseQueryString(request)
          let key = 'category-list'

          let cachedData = this.getCacheLocalStorage(key)

          if(cachedData.expired){
            vm.axios.getListCategory(request, function (response) {
              vm.setCategoryList(response.data.data.items)
              vm.$session.set('listCategory', response.data.data.items)
              vm.setCacheLocalStorage(key, response.data.data.items, 5, 'minutes')
              vm.bindNav();
            })
          }else{
            vm.setCategoryList(cachedData.data)
            vm.$session.set('listCategory', cachedData.data)
            vm.bindNav();
          }
        } else {
          vm.bindNav();
        }

        /*if (vm.$route.name == vm.$const.HEADER_MENU.CATEGORY || vm.$route.name == vm.$const.HEADER_MENU.COMBO_DETAIL ||
          vm.$route.name == vm.$const.HEADER_MENU.TOPIC || vm.$route.name == vm.$const.HEADER_MENU.TOPIC_DETAIL) {

        }*/
      },
      bindNav: function () {
        let vm = this
        let selectedCategory = null;
        let selectedSubCategory = null;
        let slugParent = vm.$route.params.slug
        let slugSub = vm.$route.params.sub

        if (slugParent == vm.$const.MENU_COUPON) {
          let selectedCategory = {};
          selectedCategory.uuid = vm.$const.COUPON_UUID;

          vm.setSelectedCategory(selectedCategory)
          vm.$root.$emit('showHideCart', false)
          //vm.$router.push({'name': 'login'})
          return;
        } else if (vm.$route.name == vm.$const.HEADER_MENU.CATEGORY) {
          if (!slugParent && vm.categoryList && vm.categoryList.length) {
            if (vm.categoryList[0].lower_categories && vm.categoryList[0].lower_categories.length) {
              vm.setSelectedCategory(vm.categoryList[0])
              vm.setSelectedSubCategory(vm.categoryList[0].lower_categories[0])
              vm.redirectToMenuPage(vm.categoryList[0].slug, vm.categoryList[0].lower_categories[0].slug, null, true);
              return;
            } else {
              vm.setSelectedCategory(vm.categoryList[0])
              vm.setSelectedSubCategory(null)
              vm.redirectToMenuPage(vm.categoryList[0].slug, null, null, true);
              return;
            }
          }
        }

        if (slugParent == vm.$const.MENU_COUPON) {
          selectedCategory = {};
          selectedCategory.uuid = vm.$const.COUPON_UUID;
        } else if (vm.categoryList && vm.categoryList.length) {
          for (let r in vm.categoryList) {
            if (r == 0) {
              let _menuDeal = {
                slug: vm.categoryList[r].slug,
                uuid: vm.categoryList[r].uuid,
                lower_categories: vm.categoryList[r].lower_categories
              }
              vm.$store.commit('setMenuDeal', _menuDeal)
            }

            if (vm.categoryList[r].slug == slugParent) {
              selectedCategory = vm.categoryList[r];
              vm.sub = vm.categoryList[r].lower_categories

              let lowerCategories = vm.categoryList[r].lower_categories;

              if (lowerCategories && lowerCategories.length) {
                if (!slugSub) {
                  let subCategory = vm.categoryList[r].lower_categories[0];

                  vm.setSelectedCategory(selectedCategory)
                  vm.setSelectedSubCategory(subCategory)
                  vm.redirectToMenuPage(selectedCategory.slug, subCategory.slug, null, true);
                  return;
                } else {

                  for (let s in lowerCategories) {
                    if (lowerCategories[s].slug == slugSub) {
                      selectedSubCategory = lowerCategories[s]
                      break;
                    }
                  }
                }
              }

              break;
            }
          }
        }

        vm.$session.set('categoryUuid', selectedCategory ? selectedCategory.uuid : '')
        vm.setSelectedCategory(selectedCategory)
        vm.setSelectedSubCategory(selectedSubCategory)
      },
      registerEventIdleTime: function () {
        window.addEventListener("mousemove", this.executeIdleTimeOut);
        window.addEventListener("mousedown", this.executeIdleTimeOut);
        window.addEventListener("keypress", this.executeIdleTimeOut);
        window.addEventListener("DOMMouseScroll", this.executeIdleTimeOut);
        window.addEventListener("mousewheel", this.executeIdleTimeOut);
        window.addEventListener("touchmove", this.executeIdleTimeOut);
        window.addEventListener("MSPointerMove", this.executeIdleTimeOut);
        window.addEventListener("click", this.executeIdleTimeOut);
      },
      executeIdleTimeOut: function (e) {
        let vm = this
        if (!vm.isManipulate) {
          vm.isManipulate = true

          checkIdleTime(vm, function (res) {
            if (res) {
              vm.$router.go()
            }

            vm.isManipulate = false
          })
        }
      },
      setDirection() {
        if (this.$i18n.locale == this.$const.LANG_ARABIC) {
          this.setUIDirection('rtl')
          let html = document.getElementsByTagName('body')[0];
          html.dir = 'rtl';

          html = document.getElementsByTagName('html')[0];
          html.dir = 'rtl';
          html.lang="ar"

          //this.direction = 'rtl'
        }
      },
      getDataErrorMessage () {
        var vm = this
        let messages = this.$session.get('messages')
        const timestamp = this.$session.get('timestamp_message')
        const params = {
          'ignore_limit': 1,
          'timestamp': 0
        }
        if (timestamp) {
          params.timestamp = timestamp
        }
        if (!messages) {
          messages = []
        }
        this.axios.apiTenant.getErrorMessage(params, response => {
          // Create session message
          for (let i = 0; i < response.data.data.items.length; i++) {
            const element = response.data.data.items[i]
            let check = false
            for (let i = 0; i < messages.length; i++) {
              const item = messages[i]
              if (item.error_code === element.error_code) {
                if (element.active === 1) {
                  messages[i] = element
                } else {
                  messages.splice(i, 1)
                }
                check = true
                break
              }
            }
            if (!check && element.active === 1) {
              messages.push(element)
            }
          }
          vm.$session.set('messages', messages)
          vm.$session.set('timestamp_message', response.data.data.timestamp)
        }, error => {
          console.log('error', error)
        })
      },
      initMaintainModeEvent () {
        var vm = this
        this.$root.$on('onMaintainMode', () => {
          const params = { 'scope': 'web_maintenance' }
          // call api check maintain mode
          vm.axios.apiTenant.getSocialByClient(params, function (response) {
            if (response.data !== undefined && response.data === 1) {
              vm.$modal.show(ModalMaintain, {
                name: 'modal-notify',
                title: vm.getTextInErrorMessage(vm.$const.MAINTAIN_CODE_TITLE) || vm.$t('maintain_title'),
                message: vm.getTextInErrorMessage(vm.$const.MAINTAIN_CODE_MESSAGE) || vm.$t('maintain_message')
              }, {
                class: 'modal-maintain',
                height: 'auto',
                transition: 'nice-modal-fade',
                overlayTransition: 'overlay-fade',
                clickToClose: false,
                name: 'modal-notify'
              })
            }
          })
        })
      },
      destroyed () {
        this.$root.$off('onMaintainMode')
      }
    }
  }

  function registerEvents(vm) {
    vm.$bus.$on(vm.$const.EVENT_BUS.LOADING, ($status) => {
      if ($status) {
        vm.loadingCount++
      } else if (vm.loadingCount > 0) {
        vm.loadingCount--
      }
    })

    vm.$bus.$on(vm.$const.EVENT_BUS.LOAD_CATEGORY, (loadAgain = false) => {
      vm.getCategoryList(loadAgain)
    })

    vm.$bus.$on(vm.$const.EVENT_BUS.SHOW_ASAP, () => {
      vm.showOrderASAP(vm.$t('hutfe.error_text_fe_order_time_in_past'))
    })

    vm.$bus.$on(vm.$const.EVENT_BUS.SHOW_MODAL_DELIVERY, () => {
      vm.showModalDelivery(vm.$t('hutfe.error_text_fe_delivery_temporarily_unavailable'))
    })

    vm.$bus.$on(vm.$const.EVENT_BUS.SHOW_MODAL_PICKUP, () => {
      vm.showModalPickup(vm.$t('hutfe.error_text_fe_pickup_temporarily_unavailable'))
    })

    vm.$root.$on(vm.$const.EVENT_BUS.REDIRECT_TO_MENU_PAGE, (slug = null, sub = null, nameseo = null, isReplace = false) => {
      if (isReplace) {
        vm.$router.replace({
          'name': 'category',
          'params': {
            slug: slug,
            sub: sub ? sub : null,
            nameseo: nameseo || null
          }
        })
      } else {
        vm.$router.push({
          'name': 'category',
          'params': {
            slug: slug,
            sub: sub ? sub : null,
            nameseo: nameseo || null
          }
        })
      }
    })
  }

  function loadCSS(vm) {
    try {
      import('@/assets/css/lang-' + vm.$i18n.locale + '.css')
    } catch (ex) {

    }
  }

  function checkIdleTime(vm, callback) {
    let time = localStorage.time
    let now = moment()

    if (time) {
      time = moment(time)

      if (time.isValid && now.diff(time, 'hours', true) >= parseInt(process.env.TIMEOUT_CART)) {
        vm.$cart.removeAll(vm, function (err, res) {
          if (callback) {
            callback(res)
          }
        })
      } else {
        if (callback) {
          callback(null)
        }
      }
    } else {
      if (callback) {
        callback(null)
      }
    }

    localStorage.time = moment()
  }
</script>



// WEBPACK FOOTER //
// src/App.vue